import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Badge,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGrid } from "@mui/x-data-grid";
import { workHistoryColumns } from "./workHistoryColumns";

interface WorkHistoryGroupProps {
  title: string;
  items: any[];
  count: number;
  defaultExpanded?: boolean;
}

const WorkHistoryGroup: React.FC<WorkHistoryGroupProps> = ({
  title,
  items,
  count,
  defaultExpanded = false,
}) => {
  return (
    <Accordion defaultExpanded={defaultExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          backgroundColor: "#f8f9fa",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Badge badgeContent={count} color="primary" sx={{ mr: 2 }}>
          <Typography
            variant="body1"
            sx={{ fontWeight: "bold", fontSize: "0.9rem" }}
          >
            {title}
          </Typography>
        </Badge>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <DataGrid
          rows={items}
          columns={workHistoryColumns}
          getRowId={(row) => row.id || Math.random().toString()}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 5 },
            },
          }}
          pageSizeOptions={[5, 10, 25]}
          disableRowSelectionOnClick
          autoHeight
          sx={{
            "& .MuiDataGrid-cell": {
              borderBottom: "1px solid #e0e0e0",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#f5f5f5",
              fontWeight: "bold",
            },
            "& .MuiDataGrid-root": {
              border: "none",
            },
          }}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default WorkHistoryGroup;
